export enum PaymentTransactionType {
  TRF = 'TRF',
  DD = 'DD',
}
